export const GET_REPORT_DATA = 'beneficiary.GET_REPORT_DATA'
export const GET_REPORT_TO_INSURANCE_DATA = 'beneficiary.GET_REPORT_TO_INSURANCE_DATA'
export const SET_REPORT_DATA = 'beneficiary.SET_REPORT_DATA'

export const GET_BENEFICIARIES_TO_SELECT = 'beneficiary.GET_BENEFICIARIES_TO_SELECT'
export const GET_BENEFICIARIES_WITH_COLLECTION = 'beneficiary.GET_BENEFICIARIES_WITH_COLLECTION'
export const GET_CSV_DATA = 'beneficiary.GET_CSV_DATA'
export const SET_BENEFICIARIES = 'beneficiary.SET_BENEFICIARIES'
export const SET_BENEFICIARIES_TO_SELECT = 'beneficiary.SET_BENEFICIARIES_TO_SELECT'

export const SAVE_BENEFICIARY = 'beneficiary.SAVE_BENEFICIARY'
export const CLEAR_BENEFICIARY = 'beneficiary.CLEAR_BENEFICIARY'

export const CHECK_BENEFICIARIES_READ = 'beneficiary.CHECK_BENEFICIARIES_READ'
export const SET_BENEFICIARIES_CHECKED = 'beneficiary.SET_BENEFICIARIES_CHECKED'

export const SAVE_BENEFICIARIES_EXAMS = 'beneficiary.SAVE_BENEFICIARIES_EXAMS'

export const GET_COUNT_BENEFICIARIES_WITH_COLLECTION = 'beneficiary.GET_COUNT_BENEFICIARIES_WITH_COLLECTION'
export const SET_COUNT_BENEFICIARIES_WITH_COLLECTION = 'beneficiary.SET_COUNT_BENEFICIARIES_WITH_COLLECTION'

export const GET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME = 'beneficiary.GET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME'
export const SET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME = 'beneficiary.SET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME'

export const SET_BENEFICIARIES_TO_MESSAGE = 'beneficiary.SET_BENEFICIARIES_TO_MESSAGE'
export const GET_BENEFICIARIES_TO_MESSAGE = 'beneficiary.GET_BENEFICIARIES_TO_MESSAGE'

export const GET_BENEFICIARIES_TO_ACCESS_CONTROL = 'beneficiary.GET_BENEFICIARIES_TO_ACCESS_CONTROL'
export const SET_BENEFICIARIES_TO_ACCESS_CONTROL = 'beneficiary.SET_BENEFICIARIES_TO_ACCESS_CONTROL'

export const UPDATE_BENEFICIARY_PHOTO_IN_STORE = 'beneficiary.UPDATE_BENEFICIARY_PHOTO_IN_STORE'

export const getCountBeneficiariesWithCollection = (params, callback) => ({
  type: GET_COUNT_BENEFICIARIES_WITH_COLLECTION,
  params,
  callback,
})

export const setCountBeneficiariesWithCollection = (beneficiaryWithCollectionCount) => ({
  type: SET_COUNT_BENEFICIARIES_WITH_COLLECTION,
  beneficiaryWithCollectionCount,
})

export const getReport = (params, callback) => ({
  type: GET_REPORT_DATA,
  params,
  callback,
})

export const getReportToInsurance = (params, callback) => ({
  type: GET_REPORT_TO_INSURANCE_DATA,
  params,
  callback,
})

export const setReport = (reportData) => ({
  type: SET_REPORT_DATA,
  reportData,
})

export const getBeneficiariesWithCollection = (params, callback) => ({
  type: GET_BENEFICIARIES_WITH_COLLECTION,
  params,
  callback,
})

export const getBeneficiariesToMessage = (params, callback) => ({
  type: GET_BENEFICIARIES_TO_MESSAGE,
  params,
  callback,
})

export const setBeneficiariesToMessage = (beneficiaries) => ({
  type: SET_BENEFICIARIES_TO_MESSAGE,
  beneficiaries
})

export const getBeneficiariesToSelect = (params, callback) => ({
  type: GET_BENEFICIARIES_TO_SELECT,
  params,
  callback,
})

export const getCsvData = (params, callback) => ({
  type: GET_CSV_DATA,
  params,
  callback,
})

export const setBeneficiaries = (beneficiaries) => ({
  type: SET_BENEFICIARIES,
  beneficiaries,
})

export const setBeneficiariesToSelect = (beneficiaries) => ({
  type: SET_BENEFICIARIES_TO_SELECT,
  beneficiaries,
})

export const saveBeneficiary = (data, callback) => ({
  type: SAVE_BENEFICIARY,
  data,
  callback,
})

export const clearBeneficiary = () => ({
  type: CLEAR_BENEFICIARY,
})

export const checkBeneficiariesRead = (params) => ({
  type: CHECK_BENEFICIARIES_READ,
  params
})

export const setBeneficiariesChecked = (beneficiaries) => ({
  type: SET_BENEFICIARIES_CHECKED,
  beneficiaries
})

export const saveBeneficiariesExams = (data, callback) => ({
  type: SAVE_BENEFICIARIES_EXAMS,
  data,
  callback
})

export const getCountBeneficiariesByCompanyOrProgramme = (params, callback) => ({
  type: GET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME,
  params,
  callback,
})

export const setCountBeneficiariesByCompanyOrProgramme = (beneficiaryWithCollectionCount) => ({
  type: SET_COUNT_BENEFICIARIES_BY_COMPANY_OR_PROGRAMME,
  beneficiaryWithCollectionCount
})

export const getBeneficiariesToAccessControl = (params, callback) => ({
  type: GET_BENEFICIARIES_TO_ACCESS_CONTROL,
  params,
  callback,
})

export const setBeneficiariesToAccessControl = (beneficiaries) => ({
  type: SET_BENEFICIARIES_TO_ACCESS_CONTROL,
  beneficiaries,
})

export const updateBeneficiaryPhotoInStore = (beneficiaryId, base64) => ({
  type: UPDATE_BENEFICIARY_PHOTO_IN_STORE, beneficiaryId, base64,
})
